(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-eco-labels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ps-eco-labels')) {
    customElements.define('ps-eco-labels', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-eco-content]');
        this.cache = new Map([[this.dataset.variantId, this.content.innerHTML]]);
        this.events = new AbortController();
        this.addEventListener('error', (event) => {
          if (!(event.target instanceof HTMLImageElement)) return;
          const item = event.target.closest('.ps-eco__item');
          const group = item?.closest('.ps-eco__group');
          item?.remove();
          if (group && !group.querySelector('.ps-eco__item')) group.remove();
        }, { capture: true, signal: this.events.signal });
        document.addEventListener('change', (event) => {
          const input = event.target;
          const formId = input.form?.getAttribute('id');
          if (input.name === 'id' && formId === `product-form-${this.dataset.productId}`) {
            this.showVariant(String(input.value));
          }
          const picker = input.closest?.('variant-radios, variant-selects');
          if (picker?.dataset.product === this.dataset.productId && !picker.currentVariant) {
            this.pending?.abort();
            this.dataset.variantId = '';
            this.content.replaceChildren();
          }
        }, { signal: this.events.signal });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.pending?.abort();
      }
      async showVariant(id) {
        if (!/^\d+$/.test(id) || id === this.dataset.variantId) return;
        this.pending?.abort();
        this.content.replaceChildren();
        this.dataset.variantId = id;
        if (this.cache.has(id)) {
          this.content.innerHTML = this.cache.get(id);
          return;
        }
        const controller = new AbortController();
        this.pending = controller;
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const url = new URL(location.href);
          url.searchParams.set('variant', id);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Section unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const labels = html.querySelector(`ps-eco-labels[data-product-id="${this.dataset.productId}"]`);
          const next = labels?.querySelector('[data-eco-content]');
          if (!next || labels.dataset.variantId !== id || this.dataset.variantId !== id || controller.signal.aborted) return;
          this.cache.set(id, next.innerHTML);
          if (this.cache.size > 64) this.cache.delete(this.cache.keys().next().value);
          this.content.replaceChildren(...next.childNodes);
        } catch (error) {
          if (this.dataset.variantId === id) this.dataset.variantId = '';
        } finally {
          clearTimeout(timeout);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ps-storefront-review-fixes"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('ps-filter-translations');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const names = {pris: 'price', sök: 'search', kategorier: 'categories', tillgänglighet: 'availability'};
  const cache = new Map();
  const pending = new WeakMap();
  const queue = [];
  let active = 0;
  let scheduled = false;
  const parser = new DOMParser();

  function pump() {
    while (active < 4 && queue.length) {
      const task = queue.shift();
      active++;
      fetch(task.url, {credentials: 'same-origin', signal: AbortSignal.timeout(12000)})
        .then(response => {
          if (!response.ok) throw new Error('Marker response unavailable');
          return response.json();
        })
        .then(task.resolve, error => { cache.delete(task.url); task.reject(error); })
        .finally(() => { active--; pump(); });
    }
  }

  function loadMarker(url) {
    if (!cache.has(url)) {
      cache.set(url, new Promise((resolve, reject) => queue.push({url, resolve, reject})));
      pump();
    }
    return cache.get(url);
  }

  function hydrate(card) {
    if (card.querySelector('.ps-card-flags')) return;
    const link = card.querySelector('a.card-link[href*="/products/"]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    url.searchParams.set('view', 'ps-card-mark');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const key = url.href;
    if (pending.get(card) === key) return;
    pending.set(card, key);
    loadMarker(key).then(html => {
      if (!card.isConnected || pending.get(card) !== key || card.querySelector('.ps-card-flags')) return;
      const marker = parser.parseFromString(html, 'text/html').querySelector('.ps-eco-stamp');
      if (!marker) return;
      const flags = document.createElement('div');
      flags.className = 'ps-card-flags';
      flags.append(marker);
      const badge = card.querySelector('.card-product__wrapper > .card__badge');
      if (badge) flags.append(badge);
      card.prepend(flags);
    }).catch(() => { pending.delete(card); });
  }

  function refresh() {
    scheduled = false;
    document.querySelectorAll('.cloud-search-filter__name, .sidebarBlock-heading > .facets__text, .sidebarBlock-heading').forEach(element => {
      if (element.matches('.sidebarBlock-heading') && element.children.length) return;
      const key = names[element.textContent.trim().toLocaleLowerCase('sv')];
      if (key && element.textContent !== labels[key]) element.textContent = labels[key];
    });
    document.querySelectorAll('.cloud-search-filter input[placeholder]').forEach(element => {
      if (element.placeholder.trim().toLocaleLowerCase('sv') === 'sök') element.placeholder = labels.search;
    });
    if (location.pathname.includes('/a/search')) {
      document.querySelectorAll('main .product-item > .card').forEach(hydrate);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  refresh();
  new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
})();
  } catch(e) { console.error(e); }
})();

})();
